var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBaseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2437_38503)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2437_38503",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.37216 24 0 18.6278 0 12C0 5.37216 5.37216 0 12 0C18.6278 0 24 5.37216 24 12C24 18.6278 18.6278 24 12 24Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2437_38503)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9962 11.9943L-4.97656 11.8896L-4.9612 11.2656L11.9962 11.9943Z",
    fill: "#FEFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 11.9968L-4.96094 11.3719L-4.93502 10.8516L11.9994 11.9968Z",
    fill: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9948 11.9975L-4.94531 10.9569L-4.90691 10.4375L11.9948 11.9975Z",
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9954 11.9982L-4.91406 10.5418L-4.86318 10.0234L11.9954 11.9982Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9932 11.9969L-4.875 10.1259L-4.81164 9.60938L11.9932 11.9969Z",
    fill: "#FAFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.997 11.9947L-4.82031 9.71083L-4.74447 9.19531L11.997 11.9947Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 11.9983L-4.75781 9.3017L-4.66949 8.78906L11.998 11.9983Z",
    fill: "#F8FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9973 12.0001L-4.6875 8.89353L-4.5867 8.38281L11.9973 12.0001Z",
    fill: "#F7FAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9948 11.9999L-4.60938 8.48536L-4.49514 7.97656L11.9948 11.9999Z",
    fill: "#F6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9973 11.9969L-4.51562 8.07527L-4.3889 7.57031L11.9973 11.9969Z",
    fill: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9971 11.9997L-4.41406 7.67396L-4.27582 7.17188L11.9971 11.9997Z",
    fill: "#F4F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9961 11.9987L-4.30469 7.27168L-4.15301 6.77344L11.9961 11.9987Z",
    fill: "#F3F7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9923 11.9948L-4.1875 6.8694L-4.02334 6.375L11.9923 11.9948Z",
    fill: "#F2F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9946 11.9959L-4.05469 6.47494L-3.87901 5.98438L11.9946 11.9959Z",
    fill: "#F1F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9941 11.9931L-3.91406 6.07951L-3.72686 5.59375L11.9941 11.9931Z",
    fill: "#F0F5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 11.9943L-3.76562 5.6919L-3.5669 5.21094L11.9928 11.9943Z",
    fill: "#EFF4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 11.9985L-3.60156 5.31114L-3.39036 4.83594L11.9975 11.9985Z",
    fill: "#EEF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9926 11.9989L-3.4375 4.93134L-3.21478 4.46094L11.9926 11.9989Z",
    fill: "#EDF3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9947 11.9954L-3.25781 4.55154L-3.02357 4.08594L11.9947 11.9954Z",
    fill: "#ECF2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.995 11.9939L-3.07031 4.17763L-2.82455 3.71875L11.995 11.9939Z",
    fill: "#EBF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9935 11.9965L-2.875 3.81346L-2.61868 3.35938L11.9935 11.9965Z",
    fill: "#EAF1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 12.0001L-2.66406 3.45421L-2.39622 3.00781L11.999 12.0001Z",
    fill: "#E9F0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9958 11.9999L-2.45312 3.09689L-2.17473 2.65625L11.9958 11.9999Z",
    fill: "#E8EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 11.993L-2.22656 2.73765L-1.93664 2.30469L11.9997 11.993Z",
    fill: "#E7EFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9949 11.9959L-2 2.39403L-1.70048 1.96875L11.9949 11.9959Z",
    fill: "#E6EEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9971 11.9931L-1.75781 2.05137L-1.44773 1.63281L11.9971 11.9931Z",
    fill: "#E5EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 11.9924L-1.50781 1.71557L-1.18717 1.30469L11.9994 11.9924Z",
    fill: "#E4EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9931 11.9995L-1.25781 1.39443L-0.927572 0.992188L11.9931 11.9995Z",
    fill: "#E3ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9937 11.9932L-0.992188 1.06644L-0.652348 0.671875L11.9937 11.9932Z",
    fill: "#E2EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9955 11.9957L-0.71875 0.753108L-0.36931 0.367188L11.9955 11.9957Z",
    fill: "#E1EBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9974 11.9983L-0.4375 0.447592L-0.07846 0.0703125L11.9974 11.9983Z",
    fill: "#E0EAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 11.9942L-0.148438 0.142078L0.220203 -0.226562L11.9994 11.9942Z",
    fill: "#DFE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 11.9981L0.140625 -0.149733L0.516945 -0.507812L11.9928 11.9981Z",
    fill: "#DEE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.996 11.9953L0.445312 -0.439622L0.831232 -0.789062L11.996 11.9953Z",
    fill: "#DDE8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9926 11.9994L0.75 -0.714848L1.14456 -1.05469L11.9926 11.9994Z",
    fill: "#DCE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.997 11.9958L1.07031 -0.990072L1.47255 -1.32031L11.997 11.9958Z",
    fill: "#DBE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9957 11.9924L1.39062 -1.25844L1.80151 -1.57812L11.9957 11.9924Z",
    fill: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9956 11.997L1.71875 -1.51023L2.13731 -1.82031L11.9956 11.997Z",
    fill: "#D9E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9964 11.9997L2.05469 -1.75517L2.47997 -2.05469L11.9964 11.9997Z",
    fill: "#D8E5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9925 11.9948L2.39062 -2.0001L2.82358 -2.28906L11.9925 11.9948Z",
    fill: "#D7E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 11.9968L2.74219 -2.22941L3.18283 -2.50781L11.9975 11.9968Z",
    fill: "#D6E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9968 11.998L3.09375 -2.45091L3.54015 -2.71875L11.9968 11.998Z",
    fill: "#D5E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.999 11.9975L3.45312 -2.66555L3.90625 -2.92188L11.999 11.9975Z",
    fill: "#D4E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9955 11.9971L3.8125 -2.87143L4.27138 -3.11719L11.9955 11.9971Z",
    fill: "#D3E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.996 11.9939L4.17969 -3.07141L4.64529 -3.30469L11.996 11.9939Z",
    fill: "#D2E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9985 11.9977L4.55469 -3.2548L5.02509 -3.47656L11.9985 11.9977Z",
    fill: "#D1E0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9972 11.9928L4.92969 -3.43724L5.40585 -3.64844L11.9972 11.9928Z",
    fill: "#D0DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 11.994L5.3125 -3.60501L5.79442 -3.80469L11.9999 11.994Z",
    fill: "#CFDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9977 11.9925L5.69531 -3.76593L6.18203 -3.95312L11.9977 11.9925Z",
    fill: "#CEDEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 11.9979L6.08594 -3.91026L6.5765 -4.08594L11.9995 11.9979Z",
    fill: "#CDDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 11.9928L6.47656 -4.05651L6.97096 -4.21875L11.9975 11.9928Z",
    fill: "#CCDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9926 11.9946L6.86719 -4.18522L7.36543 -4.33594L11.9926 11.9946Z",
    fill: "#CBDCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9927 11.9937L7.26562 -4.30707L7.76771 -4.44531L11.9927 11.9937Z",
    fill: "#CADBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9976 11.9989L7.67188 -4.41234L8.17683 -4.53906L11.9976 11.9989Z",
    fill: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 11.9934L8.07812 -4.51953L8.58597 -4.63281L11.9997 11.9934Z",
    fill: "#C8DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9989 11.994L8.48438 -4.61014L8.99413 -4.71094L11.9989 11.994Z",
    fill: "#C7D9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9972 11.9928L8.89062 -4.69197L9.40326 -4.78125L11.9972 11.9928Z",
    fill: "#C6D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9935 11.9967L9.29688 -4.75914L9.8124 -4.83594L11.9935 11.9967Z",
    fill: "#C5D8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9948 11.9978L9.71094 -4.81945L10.2274 -4.88281L11.9948 11.9978Z",
    fill: "#C4D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.996 11.9972L10.125 -4.87099L10.6434 -4.92188L11.996 11.9972Z",
    fill: "#C3D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9954 11.9947L10.5391 -4.91472L11.0584 -4.95312L11.9954 11.9947Z",
    fill: "#C2D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9938 11.9964L10.9531 -4.94379L11.4734 -4.96875L11.9938 11.9964Z",
    fill: "#C1D5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9962L11.375 -4.96408L11.8953 -4.97656L12 11.9962Z",
    fill: "#C0D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9974 11.9943L11.7891 -4.97656H12.3094L11.9974 11.9943Z",
    fill: "#BFD4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9943L12.2083 -4.97656L12.7286 -4.96312L12 11.9943Z",
    fill: "#BED3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9994L12.625 -4.96094L13.1443 -4.93502L12 11.9994Z",
    fill: "#BDD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9948L13.0406 -4.94531L13.56 -4.90691L12 11.9948Z",
    fill: "#BCD2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9954L13.4563 -4.91406L13.9747 -4.86318L12 11.9954Z",
    fill: "#BBD1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9932L13.8701 -4.875L14.3875 -4.81164L12 11.9932Z",
    fill: "#BAD0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.997L14.2838 -4.82031L14.7994 -4.74447L12 11.997Z",
    fill: "#B9D0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.998L14.6957 -4.75781L15.2093 -4.66949L12 11.998Z",
    fill: "#B8CFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9973L15.1066 -4.6875L15.6173 -4.5867L12 11.9973Z",
    fill: "#B7CEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9948L15.5146 -4.60938L16.0234 -4.49514L12 11.9948Z",
    fill: "#B6CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9973L15.9216 -4.51562L16.4266 -4.3889L12 11.9973Z",
    fill: "#B5CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9971L16.3258 -4.41406L16.8269 -4.27582L12 11.9971Z",
    fill: "#B4CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9961L16.727 -4.30469L17.2253 -4.15301L12 11.9961Z",
    fill: "#B3CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9923L17.1254 -4.1875L17.6198 -4.02334L12 11.9923Z",
    fill: "#B2CBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9946L17.521 -4.05469L18.0115 -3.87901L12 11.9946Z",
    fill: "#B1CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9941L17.9136 -3.91406L18.3994 -3.72686L12 11.9941Z",
    fill: "#B0C9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9928L18.3014 -3.76562L18.7834 -3.5669L12 11.9928Z",
    fill: "#AFC9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9975L18.6864 -3.60156L19.1626 -3.39036L12 11.9975Z",
    fill: "#AEC8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9926L19.0675 -3.4375L19.5379 -3.21478L12 11.9926Z",
    fill: "#ADC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9947L19.4438 -3.25781L19.9094 -3.02357L12 11.9947Z",
    fill: "#ACC7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.995L19.8163 -3.07031L20.2752 -2.82455L12 11.995Z",
    fill: "#ABC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9935L20.183 -2.875L20.6371 -2.61868L12 11.9935Z",
    fill: "#AAC5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.999L20.5459 -2.66406L20.9923 -2.39622L12 11.999Z",
    fill: "#A9C5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9958L20.903 -2.45312L21.3427 -2.17473L12 11.9958Z",
    fill: "#A8C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9997L21.2554 -2.22656L21.6883 -1.93664L12 11.9997Z",
    fill: "#A7C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9949L21.6019 -2L22.0272 -1.70048L12 11.9949Z",
    fill: "#A6C3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9971L21.9418 -1.75781L22.3603 -1.44773L12 11.9971Z",
    fill: "#A5C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9994L22.2768 -1.50781L22.6867 -1.18717L12 11.9994Z",
    fill: "#A4C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9931L22.6051 -1.25781L23.0074 -0.927572L12 11.9931Z",
    fill: "#A3C1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9937L22.9267 -0.992188L23.3213 -0.652348L12 11.9937Z",
    fill: "#A2C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9955L23.2426 -0.71875L23.6285 -0.36931L12 11.9955Z",
    fill: "#A1BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9974L23.5507 -0.4375L23.928 -0.07846L12 11.9974Z",
    fill: "#A0BFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9994L23.8522 -0.148438L24.2208 0.220203L12 11.9994Z",
    fill: "#9FBEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9928L24.1469 0.140625L24.5059 0.516945L12 11.9928Z",
    fill: "#9EBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.996L24.4349 0.445312L24.7843 0.831232L12 11.996Z",
    fill: "#9DBDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9926L24.7142 0.75L25.0541 1.14456L12 11.9926Z",
    fill: "#9CBCFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.997L24.9859 1.07031L25.3162 1.47255L12 11.997Z",
    fill: "#9BBBFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9957L25.2509 1.39062L25.5706 1.80151L12 11.9957Z",
    fill: "#9ABAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9956L25.5072 1.71875L25.8173 2.13731L12 11.9956Z",
    fill: "#99BAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9964L25.7549 2.05469L26.0544 2.47997L12 11.9964Z",
    fill: "#98B9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9925L25.9949 2.39062L26.2838 2.82358L12 11.9925Z",
    fill: "#97B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9975L26.2262 2.74219L26.5046 3.18283L12 11.9975Z",
    fill: "#96B8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9968L26.449 3.09375L26.7168 3.54015L12 11.9968Z",
    fill: "#95B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.999L26.663 3.45312L26.9194 3.90625L12 11.999Z",
    fill: "#94B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9955L26.8685 3.8125L27.1133 4.27138L12 11.9955Z",
    fill: "#93B6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.996L27.0643 4.17969L27.2986 4.64529L12 11.996Z",
    fill: "#92B5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9985L27.2525 4.55469L27.4742 5.02509L12 11.9985Z",
    fill: "#91B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9972L27.4301 4.92969L27.6413 5.40585L12 11.9972Z",
    fill: "#90B4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9999L27.599 5.3125L27.7978 5.79442L12 11.9999Z",
    fill: "#8FB3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9977L27.7584 5.69531L27.9456 6.18203L12 11.9977Z",
    fill: "#8EB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9995L27.9082 6.08594L28.0838 6.5765L12 11.9995Z",
    fill: "#8DB2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9975L28.0483 6.47656L28.2115 6.97096L12 11.9975Z",
    fill: "#8CB1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9926L28.1789 6.86719L28.3306 7.36543L12 11.9926Z",
    fill: "#8BB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9927L28.2998 7.26562L28.439 7.76771L12 11.9927Z",
    fill: "#8AB0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9976L28.4112 7.67188L28.5379 8.17683L12 11.9976Z",
    fill: "#89AFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9997L28.513 8.07812L28.6262 8.58597L12 11.9997Z",
    fill: "#88AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9989L28.6032 8.48438L28.705 8.99413L12 11.9989Z",
    fill: "#87AEFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9972L28.6848 8.89062L28.7741 9.40326L12 11.9972Z",
    fill: "#86ADFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9935L28.7558 9.29688L28.8326 9.8124L12 11.9935Z",
    fill: "#85ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9948L28.8173 9.71094L28.8806 10.2274L12 11.9948Z",
    fill: "#84ACFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.996L28.8682 10.125L28.919 10.6434L12 11.996Z",
    fill: "#83ABFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9954L28.9094 10.5391L28.9478 11.0584L12 11.9954Z",
    fill: "#82AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9938L28.9402 10.9531L28.9651 11.4734L12 11.9938Z",
    fill: "#81AAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.9603 11.375L28.9728 11.8953L12 12Z",
    fill: "#80A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.9974L28.9699 11.7891V12.3094L12 11.9974Z",
    fill: "#7FA8FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.9699 12.2083L28.9574 12.7286L12 12Z",
    fill: "#7EA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.9603 12.625L28.9344 13.1443L12 12Z",
    fill: "#7DA7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.9402 13.0406L28.9018 13.56L12 12Z",
    fill: "#7CA6FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.9094 13.4563L28.8586 13.9747L12 12Z",
    fill: "#7BA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.8682 13.8701L28.8048 14.3875L12 12Z",
    fill: "#7AA5FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.8173 14.2838L28.7405 14.7994L12 12Z",
    fill: "#79A4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.7558 14.6957L28.6675 15.2093L12 12Z",
    fill: "#78A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.6848 15.1066L28.583 15.6173L12 12Z",
    fill: "#77A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.6032 15.5146L28.4899 16.0234L12 12Z",
    fill: "#76A2FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.513 15.9216L28.3862 16.4266L12 12Z",
    fill: "#75A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.4112 16.3258L28.273 16.8269L12 12Z",
    fill: "#74A1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.2998 16.727L28.1491 17.2253L12 12Z",
    fill: "#73A0FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.1789 17.1254L28.0157 17.6198L12 12Z",
    fill: "#729FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L28.0483 17.521L27.8736 18.0115L12 12Z",
    fill: "#719FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.9082 17.9136L27.721 18.3994L12 12Z",
    fill: "#709EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.7584 18.3014L27.5587 18.7834L12 12Z",
    fill: "#6F9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.599 18.6864L27.3878 19.1626L12 12Z",
    fill: "#6E9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.4301 19.0675L27.2074 19.5379L12 12Z",
    fill: "#6D9CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.2525 19.4438L27.0182 19.9094L12 12Z",
    fill: "#6C9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L27.0643 19.8163L26.8195 20.2752L12 12Z",
    fill: "#6B9BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L26.8685 20.183L26.6122 20.6371L12 12Z",
    fill: "#6A9AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L26.663 20.5459L26.3952 20.9923L12 12Z",
    fill: "#6999FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L26.449 20.903L26.1706 21.3427L12 12Z",
    fill: "#6899FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L26.2262 21.2554L25.9363 21.6883L12 12Z",
    fill: "#6798FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L25.9949 21.6019L25.6954 22.0272L12 12Z",
    fill: "#6697FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L25.7549 21.9418L25.4448 22.3603L12 12Z",
    fill: "#6597FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L25.5072 22.2768L25.1866 22.6867L12 12Z",
    fill: "#6496FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L25.2509 22.6051L24.9206 23.0074L12 12Z",
    fill: "#6395FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L24.9859 22.9267L24.6461 23.3213L12 12Z",
    fill: "#6294FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L24.7142 23.2426L24.3648 23.6285L12 12Z",
    fill: "#6194FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L24.4349 23.5507L24.0758 23.928L12 12Z",
    fill: "#6093FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L24.1469 23.8522L23.7792 24.2208L12 12Z",
    fill: "#5F92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L23.8522 24.1469L23.4758 24.5059L12 12Z",
    fill: "#5E92FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L23.5507 24.4349L23.1648 24.7843L12 12Z",
    fill: "#5D91FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L23.2426 24.7142L22.848 25.0541L12 12Z",
    fill: "#5C90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L22.9267 24.9859L22.5245 25.3162L12 12Z",
    fill: "#5B90FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L22.6051 25.2509L22.1942 25.5706L12 12Z",
    fill: "#5A8FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L22.2768 25.5072L21.8582 25.8173L12 12Z",
    fill: "#598EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L21.9418 25.7549L21.5165 26.0544L12 12Z",
    fill: "#588EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L21.6019 25.9949L21.168 26.2838L12 12Z",
    fill: "#578DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L21.2554 26.2262L20.8147 26.5046L12 12Z",
    fill: "#568CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L20.903 26.449L20.4566 26.7168L12 12Z",
    fill: "#558CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L20.5459 26.663L20.0928 26.9194L12 12Z",
    fill: "#548BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L20.183 26.8685L19.7242 27.1133L12 12Z",
    fill: "#538AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L19.8163 27.0643L19.3507 27.2986L12 12Z",
    fill: "#528AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L19.4438 27.2525L18.9734 27.4742L12 12Z",
    fill: "#5189FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L19.0675 27.4301L18.5914 27.6413L12 12Z",
    fill: "#5088FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L18.6864 27.599L18.2054 27.7978L12 12Z",
    fill: "#4F88FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L18.3014 27.7584L17.8157 27.9456L12 12Z",
    fill: "#4E87FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L17.9136 27.9082L17.423 28.0838L12 12Z",
    fill: "#4D86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L17.521 28.0483L17.0266 28.2115L12 12Z",
    fill: "#4C86FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L17.1254 28.1789L16.6272 28.3306L12 12Z",
    fill: "#4B85FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L16.727 28.2998L16.225 28.439L12 12Z",
    fill: "#4A84FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L16.3258 28.4112L15.8198 28.5379L12 12Z",
    fill: "#4984FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L15.9216 28.513L15.4138 28.6262L12 12Z",
    fill: "#4883FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L15.5146 28.6032L15.0038 28.705L12 12Z",
    fill: "#4782FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L15.1066 28.6848L14.5939 28.7741L12 12Z",
    fill: "#4681FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L14.6957 28.7558L14.1811 28.8326L12 12Z",
    fill: "#4581FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L14.2838 28.8173L13.7674 28.8806L12 12Z",
    fill: "#4480FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L13.8701 28.8682L13.3526 28.919L12 12Z",
    fill: "#437FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L13.4563 28.9094L12.937 28.9478L12 12Z",
    fill: "#427FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L13.0406 28.9402L12.5203 28.9651L12 12Z",
    fill: "#417EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12L12.625 28.9603L12.1037 28.9728L12 12Z",
    fill: "#407DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9926 12L12.201 28.9699H11.6797L11.9926 12Z",
    fill: "#3F7DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9943 12L11.7859 28.9699L11.2656 28.9574L11.9943 12Z",
    fill: "#3E7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9968 12L11.3719 28.9603L10.8516 28.9344L11.9968 12Z",
    fill: "#3D7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 12L10.9569 28.9402L10.4375 28.9018L11.9975 12Z",
    fill: "#3C7BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9982 12L10.5418 28.9094L10.0234 28.8586L11.9982 12Z",
    fill: "#3B7AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9969 12L10.1259 28.8682L9.60938 28.8048L11.9969 12Z",
    fill: "#3A79FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9947 12L9.71083 28.8173L9.19531 28.7405L11.9947 12Z",
    fill: "#3979FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9983 12L9.3017 28.7558L8.78906 28.6675L11.9983 12Z",
    fill: "#3878FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 12L8.89353 28.6848L8.38281 28.583L12.0001 12Z",
    fill: "#3777FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 12L8.48536 28.6032L7.97656 28.4899L11.9999 12Z",
    fill: "#3677FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9969 12L8.07527 28.513L7.57031 28.3862L11.9969 12Z",
    fill: "#3576FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 12L7.67396 28.4112L7.17188 28.273L11.9997 12Z",
    fill: "#3475FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9987 12L7.27168 28.2998L6.77344 28.1491L11.9987 12Z",
    fill: "#3375FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9948 12L6.8694 28.1789L6.375 28.0157L11.9948 12Z",
    fill: "#3274FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9959 12L6.47494 28.0483L5.98438 27.8736L11.9959 12Z",
    fill: "#3173FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9931 12L6.07951 27.9082L5.59375 27.721L11.9931 12Z",
    fill: "#3073FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9943 12L5.6919 27.7584L5.21094 27.5587L11.9943 12Z",
    fill: "#2F72FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9985 12L5.31114 27.599L4.83594 27.3878L11.9985 12Z",
    fill: "#2E71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9989 12L4.93134 27.4301L4.46094 27.2074L11.9989 12Z",
    fill: "#2D71FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9954 12L4.55154 27.2525L4.08594 27.0182L11.9954 12Z",
    fill: "#2C70FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9939 12L4.17763 27.0643L3.71875 26.8195L11.9939 12Z",
    fill: "#2B6FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9965 12L3.81346 26.8685L3.35938 26.6122L11.9965 12Z",
    fill: "#2A6EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 12L3.45421 26.663L3.00781 26.3952L12.0001 12Z",
    fill: "#296EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 12L3.09689 26.449L2.65625 26.1706L11.9999 12Z",
    fill: "#286DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.993 12L2.73765 26.2262L2.30469 25.9363L11.993 12Z",
    fill: "#276CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9959 12L2.39403 25.9949L1.96875 25.6954L11.9959 12Z",
    fill: "#266CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9931 12L2.05137 25.7549L1.63281 25.4448L11.9931 12Z",
    fill: "#256BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9924 12L1.71557 25.5072L1.30469 25.1866L11.9924 12Z",
    fill: "#246AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9995 12L1.39443 25.2509L0.992188 24.9206L11.9995 12Z",
    fill: "#236AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9932 12L1.06644 24.9859L0.671875 24.6461L11.9932 12Z",
    fill: "#2269FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9957 12L0.753108 24.7142L0.367188 24.3648L11.9957 12Z",
    fill: "#2168FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9983 12L0.447592 24.4349L0.0703125 24.0758L11.9983 12Z",
    fill: "#2068FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9942 12L0.142078 24.1469L-0.226562 23.7792L11.9942 12Z",
    fill: "#1F67FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9981 12L-0.149733 23.8522L-0.507812 23.4758L11.9981 12Z",
    fill: "#1E66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9953 12L-0.439622 23.5507L-0.789062 23.1648L11.9953 12Z",
    fill: "#1D66FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 12L-0.714848 23.2426L-1.05469 22.848L11.9994 12Z",
    fill: "#1C65FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9958 12L-0.990072 22.9267L-1.32031 22.5245L11.9958 12Z",
    fill: "#1B64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9924 12L-1.25844 22.6051L-1.57812 22.1942L11.9924 12Z",
    fill: "#1A64FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.997 12L-1.51023 22.2768L-1.82031 21.8582L11.997 12Z",
    fill: "#1963FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9997 12L-1.75517 21.9418L-2.05469 21.5165L11.9997 12Z",
    fill: "#1862FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9948 12L-2.0001 21.6019L-2.28906 21.168L11.9948 12Z",
    fill: "#1762FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9968 12L-2.22941 21.2554L-2.50781 20.8147L11.9968 12Z",
    fill: "#1661FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.998 12L-2.45091 20.903L-2.71875 20.4566L11.998 12Z",
    fill: "#1560FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9975 12L-2.66555 20.5459L-2.92188 20.0928L11.9975 12Z",
    fill: "#1460FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9971 12L-2.87143 20.183L-3.11719 19.7242L11.9971 12Z",
    fill: "#135FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9939 12L-3.07141 19.8163L-3.30469 19.3507L11.9939 12Z",
    fill: "#125EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9977 12L-3.2548 19.4438L-3.47656 18.9734L11.9977 12Z",
    fill: "#115EFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 12L-3.43724 19.0675L-3.64844 18.5914L11.9928 12Z",
    fill: "#105DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.994 12L-3.60501 18.6864L-3.80469 18.2054L11.994 12Z",
    fill: "#0F5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9925 12L-3.76593 18.3014L-3.95312 17.8157L11.9925 12Z",
    fill: "#0E5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9979 12L-3.91026 17.9136L-4.08594 17.423L11.9979 12Z",
    fill: "#0D5BFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 12L-4.05651 17.521L-4.21875 17.0266L11.9928 12Z",
    fill: "#0C5AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9946 12L-4.18522 17.1254L-4.33594 16.6272L11.9946 12Z",
    fill: "#0B59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9937 12L-4.30707 16.727L-4.44531 16.225L11.9937 12Z",
    fill: "#0A59FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9989 12L-4.41234 16.3258L-4.53906 15.8198L11.9989 12Z",
    fill: "#0958FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9934 12L-4.51953 15.9216L-4.63281 15.4138L11.9934 12Z",
    fill: "#0857FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.994 12L-4.61014 15.5146L-4.71094 15.0038L11.994 12Z",
    fill: "#0757FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9928 12L-4.69197 15.1066L-4.78125 14.5939L11.9928 12Z",
    fill: "#0656FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9967 12L-4.75914 14.6957L-4.83594 14.1811L11.9967 12Z",
    fill: "#0555FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9978 12L-4.81945 14.2838L-4.88281 13.7674L11.9978 12Z",
    fill: "#0455FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9972 12L-4.87099 13.8701L-4.92188 13.3526L11.9972 12Z",
    fill: "#0354FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9947 12L-4.91472 13.4563L-4.95312 12.937L11.9947 12Z",
    fill: "#0253FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9964 12L-4.94379 13.0406L-4.96875 12.5203L11.9964 12Z",
    fill: "#0153FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9962 12L-4.96408 12.625L-4.97656 12.1037L11.9962 12Z",
    fill: "#0052FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9943 11.9974L-4.97656 12.2057V11.7891L11.9943 11.9974Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_38503"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseIcon);
export default __webpack_public_path__ + "static/media/base-icon.4f2833cf3bdb13fca62d1bd616f983cc.svg";
export { ForwardRef as ReactComponent };